export default input => {
  return input.replaceAll("<", "\\<")
}